import Accordion from '@/common/components/Accordion'
import { PermittedReportHeadersData } from '../types/permittedReports.type'
import Checkbox from '@/common/components/Checkbox'
import { useFormContext } from 'react-hook-form'

interface ReportsHeadersAccordionProps {
  headers?: PermittedReportHeadersData;
  pdfColumnsLimit?: number;
  selectedHeaders: string[]
  isPdfSelected: boolean
}

export default function ReportsHeadersAccordion({
  headers,
  pdfColumnsLimit = 10,
  selectedHeaders,
  isPdfSelected
}: ReportsHeadersAccordionProps) {
  const { setValue } = useFormContext()
  const mainHeaders = headers?.['__main__'] || []

  if (!isPdfSelected || mainHeaders.length === 0) return null

  const handleToggle = (headerName: string, isChecked: boolean) => {
    if (isChecked) {
      if (selectedHeaders.length < pdfColumnsLimit) {
        setValue(
          'pdf_visible_headers.__main__',
          [...selectedHeaders, headerName]
        )
      }
    } else {
      setValue(
        'pdf_visible_headers.__main__',
        selectedHeaders.filter((header: string) => header !== headerName)
      )
    }
  }

  const selectedHeadersSet = new Set(selectedHeaders);

  return (
    <Accordion
      name="reportsHeaders"
      head={`Colunas do PDF (Max: ${pdfColumnsLimit})`}
      body={
        <div className='flex flex-col gap-1'>
          {mainHeaders?.map((header) => {
            const headerName = header.name
            const isChecked = selectedHeadersSet.has(headerName)
            const isAtMaxLimit = selectedHeaders.length >= pdfColumnsLimit
            const isDisabled = !isChecked && isAtMaxLimit
            
            return (
              <Checkbox
                key={headerName}
                label={headerName}
                checked={isChecked}
                onChange={(e) => handleToggle(headerName, e.currentTarget.checked)}
                disabled={isDisabled}
              />
            )
          })}
        </div>
      }
    />
  )
}